/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from '@/lib/pwa/useOnlineStatus';

export function OfflineIndicator() {
  const online = useOnlineStatus();
  const { t } = useTranslation('core');
  if (online) return null;
  return (
    <div className="pwa-offline" role="status" aria-live="polite">
      {t('pwa.offline')}
      <style>{`
        .pwa-offline {
          position: fixed; left: 0; right: 0; bottom: 0; z-index: 1000;
          padding: 0.5rem 1rem; text-align: center;
          font-family: var(--font-body); font-size: 0.85rem;
          color: var(--color-text-primary);
          background: var(--color-warning-light);
          border-top: 1px solid var(--color-warning);
        }
      `}</style>
    </div>
  );
}
